export class AppError {

  constructor(public originalError?: any) {}
}




// WEBPACK FOOTER //
// ./src/app/errors/AppError.ts